export const isOrderedList = (contentArray) =>
  contentArray.every(
    (contentLine, index) => contentLine.substring(0, 3) === `${index + 1}. `
  );

export const isUnorderedList = (contentArray) =>
  contentArray.every((contentLine) => contentLine.substring(0, 2) === '- ');

export const isContentLineContainingIcon = (contentLine) =>
  contentLine.match(/(\[icon-\w+?\])/) !== -1;
